<template>
  <div class="HomeHeader">
    <a-row class="top">
      <a-col :span="10">
        <img src="@assets/img/logo.png" @click="router.push({
          name : 'home'
        })"/>
      </a-col>
      <a-col :span="14">
        您好<span v-if='store.state.userName' style='margin-left:10px'>{{store.state.userName}}<LoginOutlined class='icon' :style='{color:"#0D6DBF"}' @click.stop='logout'/></span>
        <span v-else>，请<span class='action' @click='toLogin'>登录</span></span>

      </a-col>  
    </a-row>
    <div class="nav">
      <a-row class="main">
        <a-col :span="14">
          <span :class='{train:documentRouter.indexOf(route.name) > -1}' @click="toHref('document')">首页</span>
         <!-- <span :class='{train:homeRouter.indexOf(route.name) > -1}' @click="toHref('home')">
            火车
            <span style='width: 0!important;height: 0!important'></span>
          </span>-->
        </a-col>
        <a-col :span="10" class='my_content'>
          <span :class='{train:myRouter.indexOf(route.name) > -1}' @click="toHref('my')">个人中心
            <span style='width: 0!important;height: 0!important'></span>
          </span>
          <!--<span class='line' style='width: 1px!important;margin-right:1px'>|</span>
          <span :class='{train:documentRouter.indexOf(route.name) > -1}' @click="toHref('document')">开放平台
            <span style='width: 0!important;height: 0!important'></span>
          </span>-->
        </a-col>
      </a-row>
    </div>
  </div>
</template>
<script>
import { useStore } from 'vuex';
import { useRouter,useRoute } from 'vue-router';
import { LoginOutlined } from '@ant-design/icons-vue';
import { Modal } from 'ant-design-vue'
import { ref,nextTick } from 'vue'

export default {
  componentname: "HomeHeader",
  components: {
      LoginOutlined,
  },
  props: {

  },
  setup () {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const toLogin = () => {
      router.push({
        name : 'login'
      })
    }

    const logout = () => {
      Modal.confirm({
          content: '您确认要退出么?',
          onOk() {
            localStorage.clear();
            sessionStorage.clear();
            router.push({
              name: "login",
            });
          },
          cancelText: "取消",
          okText: "确定",
          onCancel() {
              Modal.destroyAll();
          },
      });
    }
    
    const toOrderList = () => {
        router.push({
          name : 'orderList'
        })
    }


    const toHref = (key) => {
      router.push({
        name : key
      })
    }

    let myRouter = ['orderList','orderDetail','orderRefund','endorsed','amountList','passenger','platform'];
    let homeRouter = ['home','list','submitOrder'];
    let documentRouter = ['document'];
    
    return {
      documentRouter,
      myRouter,
      homeRouter,
      route,
      toHref,
      router,
      toOrderList,
      logout,
      toLogin,
      store,
    }
  }
}
</script>
<style  rel="stylesheet/scss" lang="scss" scoped>

.my_content{
  &>span{
    padding: 0 12px;
    width: 120px!important;
    position: relative;
    line-height: 40px;
  }
}
.line{
  padding:0!important;
}
.icon{
  margin-left:10px;
}
.top {
  width: 1200px;
  height: 90px;
  line-height: 90px;
  margin: 0 auto;
  font-size:16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;

  .ant-col-10 {
    text-align: left!important;
    img {
      height: 68px;
      cursor: pointer;
    }
  }
  .ant-col {
    text-align: right;
    color: #6D7278;
    .action {
      color: #0D6DBF;
      margin: 0 4px;
      cursor: pointer;
    }
    span {
      font-size:16px ;
      // margin-left: 16px;
      

    }
  }
}
.nav {
  width: 100%;
  height: 40px;
  background: #409EFF;
  color: #ffffff;
  .main {
    width: 1200px;
    height: 40px;
    line-height: 40px;
    margin: 0 auto;
    .ant-col {
      text-align: left;
      span {
        display: inline-block;
        width: 65px;
        height: 40px;
        text-align: center;
        cursor: pointer;
      }
      .train {
        background: #0D6DBF;
        position: relative;
        span{
          display: block;
          width: 0;
          height: 0;
          border: 7.5px solid #fff;
          position: absolute;
          bottom: 0;
          left:50%;
          margin-left: -7.5px;
          border-right:7.5px solid transparent;
          border-top:7.5px solid transparent;
          border-left:7.5px solid transparent;
        }
      }
    }
    .ant-col-10 {
      text-align: right;
      span {
        cursor: pointer;
      }
    }
  }
}
</style>
